"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.InputSlider = void 0;
var jsx_runtime_1 = require("@emotion/react/jsx-runtime");
var clsx_1 = __importDefault(require("clsx"));
var O = __importStar(require("fp-ts/Option"));
var Option_1 = require("fp-ts/Option");
var function_1 = require("fp-ts/function");
var N = __importStar(require("fp-ts/number"));
var React = __importStar(require("react"));
var FieldFormatter_1 = require("../FieldFormatter");
require("./inputSlider.css");
var InputSlider = /** @class */ (function (_super) {
    __extends(InputSlider, _super);
    function InputSlider(props) {
        var _this = _super.call(this, props) || this;
        _this.setScreenSize = function () {
            (0, function_1.pipe)(O.fromNullable(_this.sliderRail), O.map(function (sliderRail) {
                var slideRect = sliderRail.getBoundingClientRect();
                return _this.setState({
                    position: {
                        min: slideRect.left,
                        max: slideRect.right,
                    },
                });
            }));
        };
        _this.onTouchStart = function (e) {
            return (0, function_1.pipe)(O.fromNullable(_this.state.dragging), O.filter(function (drag) { return drag === false; }), O.map(function (_) {
                _this.setState({
                    dragging: true,
                    currentValue: _this.filterPositionLimits(_this.state.currentValue)(e.changedTouches['0'].clientX),
                });
            }), O.toNullable);
        };
        _this.onMouseDown = function (event) {
            (0, function_1.pipe)(O.some(event), O.filter(function (e) { return e.button === 0; }), O.map(function (_) {
                event.preventDefault();
                _this.setState({
                    dragging: true,
                    currentValue: _this.filterPositionLimits(_this.state.currentValue)(event.clientX),
                });
            }));
        };
        _this.onEventEnd = function () {
            return (0, function_1.pipe)(O.some(_this.state.currentValue), O.filter(function (current) { return current.toPrecision(2) !== _this.state.lastSentValue.toPrecision(2); }), O.match(function () { return _this.setState({ dragging: false }); }, function (current) {
                return _this.setState({
                    dragging: false,
                    currentValue: current,
                    lastSentValue: current,
                }, function () {
                    return _this.props.onChange &&
                        _this.props.onChange((current * (_this.props.value.max - _this.props.value.min)) / 100 + _this.props.value.min);
                });
            }));
        };
        _this.filterPositionLimits = function (current) { return function (coordX) {
            return (0, function_1.pipe)(O.some(coordX), O.filter(function (cX) { return _this.state.position.min < cX && cX < _this.state.position.max; }), O.map(function (cX) { return ((cX - _this.state.position.min) * 100) / (_this.state.position.max - _this.state.position.min); }), O.getOrElse(function () { return current; }));
        }; };
        _this.setValueOnMove = function (coordinateX) {
            return (0, function_1.pipe)(O.some(0), O.map(function (current) { return (coordinateX >= _this.state.position.max ? 100 : current); }), O.map(function (current) { return (coordinateX <= _this.state.position.min ? 0 : current); }), O.map(function (current) { return _this.filterPositionLimits(current)(coordinateX); }), O.map(function (current) { return _this.setState({ currentValue: current }); }), O.toUndefined);
        };
        _this.onTouchMove = function (e) { return _this.setValueOnMove(e.changedTouches['0'].clientX); };
        _this.onMouseMove = function (e) {
            e.preventDefault();
            return _this.setValueOnMove(e.clientX);
        };
        _this.round = function (value) { return Math.round(value * 100) / 100; };
        _this.renderAmount = function () {
            var _a;
            var amount = (_this.state.currentValue * (_this.props.value.max - _this.props.value.min)) / 100 + _this.props.value.min;
            var decimalDigits = (_a = _this.props.value.decimalDigits) !== null && _a !== void 0 ? _a : 0;
            switch (_this.props.value.contentType) {
                case 'currency':
                    return (0, jsx_runtime_1.jsx)(FieldFormatter_1.FieldFormatter.Money, { amount: amount, fractionDigits: decimalDigits });
                case 'numeric':
                    return (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: amount.toFixed(decimalDigits) });
                case 'percentage':
                default:
                    return (0, jsx_runtime_1.jsx)(FieldFormatter_1.FieldFormatter.Percentage, { amount: amount, scale: decimalDigits });
            }
        };
        _this.renderMarks = function () {
            return (0, function_1.pipe)(O.fromNullable(_this.props.marks), (0, Option_1.map)(function (marks) { return ((0, jsx_runtime_1.jsx)("div", __assign({ className: "input-slider-marks" }, { children: marks.map(function (mark, index) { return ((0, jsx_runtime_1.jsx)("div", { style: { left: "".concat(_this.round(mark.value), "%") } }, index)); }) }))); }), O.toNullable);
        };
        _this.sliderRail = null;
        _this.state = {
            dragging: false,
            lastSentValue: _this.calculateCurrentValueFromProps(props.value),
            currentValue: _this.calculateCurrentValueFromProps(props.value),
            position: {
                min: 0,
                max: 0,
            },
        };
        return _this;
    }
    InputSlider.prototype.componentDidMount = function () {
        window.addEventListener('resize', this.setScreenSize);
        this.setScreenSize();
    };
    InputSlider.prototype.componentWillUnmount = function () {
        window.removeEventListener('resize', this.setScreenSize);
    };
    InputSlider.prototype.calculateCurrentValueFromProps = function (value) {
        if (value.max < value.min) {
            throw new Error('max < min');
        }
        if (value.max - value.min === 0) {
            return value.min;
        }
        var currentValue = ((value.current - value.min) * 100) / (value.max - value.min);
        if (currentValue > 100) {
            return 100;
        }
        if (currentValue < 0) {
            return 0;
        }
        return currentValue;
    };
    InputSlider.prototype.componentDidUpdate = function (prevProp) {
        var areValuesEqual = O.getEq(N.Eq).equals((0, function_1.pipe)(O.fromNullable(prevProp.value), O.map(function (v) { return v.current; })), (0, function_1.pipe)(O.fromNullable(this.props.value), O.map(function (v) { return v.current; })));
        if (!areValuesEqual) {
            this.setState({
                currentValue: this.calculateCurrentValueFromProps(this.props.value),
                lastSentValue: this.calculateCurrentValueFromProps(this.props.value),
            });
        }
        if (this.state.dragging) {
            document.addEventListener('mousemove', this.onMouseMove);
            document.addEventListener('mouseup', this.onEventEnd);
            document.addEventListener('touchmove', this.onTouchMove);
            document.addEventListener('touchend', this.onEventEnd);
            return;
        }
        document.removeEventListener('mousemove', this.onMouseMove);
        document.removeEventListener('mouseup', this.onEventEnd);
        document.removeEventListener('touchmove', this.onTouchMove);
        document.removeEventListener('touchend', this.onEventEnd);
    };
    InputSlider.prototype.render = function () {
        var _this = this;
        return ((0, jsx_runtime_1.jsxs)("div", __assign({ className: "input-slider", onMouseDown: this.onMouseDown, onTouchStart: this.onTouchStart }, { children: [(0, jsx_runtime_1.jsx)("div", { className: "input-slider-rail", ref: function (sliderRail) {
                        _this.sliderRail = sliderRail;
                    } }), (0, jsx_runtime_1.jsx)("div", { className: "input-slider-not-track", style: { width: "".concat(100 - this.state.currentValue, "%") } }), (0, jsx_runtime_1.jsx)("div", { className: (0, clsx_1.default)('input-slider-handle', { active: this.state.dragging }), style: { left: "".concat(this.state.currentValue * 0.98, "%") } }), (0, jsx_runtime_1.jsx)("div", __assign({ className: (0, clsx_1.default)('input-slider-tooltip', { active: this.state.dragging }), style: { left: "".concat(this.state.currentValue * 0.98, "%") } }, { children: this.renderAmount() })), this.renderMarks()] })));
    };
    return InputSlider;
}(React.PureComponent));
exports.InputSlider = InputSlider;
InputSlider.defaultProps = {
    value: { min: 0, max: 100, current: 50, contentType: 'percentage', decimalDigits: 0 },
};
//# sourceMappingURL=InputSlider.js.map